import { useCapacitorAuth } from '~/composables/useCapacitorAuth'

export default defineNuxtPlugin(async () => {
  const isNative = useIsNative()

  if (!isNative) return

  const auth = useAuth()
  const capacitorAuth = useCapacitorAuth()

  if (!auth.loggedIn) {
    const tokens = await capacitorAuth.getTokens()
    if (tokens?.accessToken && tokens?.refreshToken) {
      try {
        await auth.setUserToken(tokens.accessToken, tokens.refreshToken)
      } catch (e) {
        console.error('Failed to restore auth tokens:', e)
        await capacitorAuth.clearTokens()
      }
    }
  }
})
